"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuestionHeader = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _HeaderTop = _interopRequireDefault(require("../shared/HeaderTop"));
var _react = _interopRequireDefault(require("react"));
var _useQuestionnaireNavigation = require("../../hooks/questionnaire/useQuestionnaireNavigation");
var _useCurrentQuestion2 = require("../../hooks/questionnaire/useCurrentQuestion");
var _BaseComponents = require("../StyledComponents/BaseComponents");
var _services = require("../../services");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var LightBackgroundGridRow = (0, _BaseComponents.LightBackground)(_r10SourceLibrary.GridRow);
var QuestionHeader = function QuestionHeader() {
  var _useCurrentQuestion = (0, _useCurrentQuestion2.useCurrentQuestion)(),
    title = _useCurrentQuestion.title,
    subtitle = _useCurrentQuestion.subtitle,
    questionIndex = _useCurrentQuestion.questionIndex;
  var _useQuestionnaireNavi = (0, _useQuestionnaireNavigation.useQuestionnaireNavigation)(),
    onRestart = _useQuestionnaireNavi.onRestart,
    isRestartVisible = _useQuestionnaireNavi.isRestartVisible,
    progressPercentage = _useQuestionnaireNavi.progressPercentage;
  (0, _useCurrentQuestion2.useViewQuestion)(questionIndex);
  var restartComponent = function restartComponent() {
    if (!isRestartVisible) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.LinkWithIcon, {
      appearance: "secondary",
      text: _services.locale.localeString('Questionnaire.RestartIcon'),
      state: "selected",
      id: "questionnaire-button-restart",
      icon: {
        name: 'refresh',
        justify: 'right'
      },
      onClick: onRestart,
      size: 2
    });
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_HeaderTop.default, {
    actionComponent: restartComponent()
  }))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 7,
      bottom: 7
    }
  }, /*#__PURE__*/_react.default.createElement(LightBackgroundGridRow, {
    justify: 'center',
    direction: 'column'
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.ProgressBar, {
    value: progressPercentage,
    appearance: 'primary'
  })))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    text: title,
    justify: 'center',
    weight: 3,
    size: 2
  })))), subtitle && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    text: subtitle,
    justify: 'center',
    size: 1
  }))));
};
exports.QuestionHeader = QuestionHeader;